import axios from "axios";

const BACKEND_URL = 'https://knowledge.compubrain.com';
export const API = `${BACKEND_URL}/api`;
export const SITE_URL = BACKEND_URL;

const http = axios.create({ baseURL: API });

export async function getStats() {
  const { data } = await http.get(`/stats`);
  return data;
}

export async function getEntity(type, slug) {
  const { data } = await http.get(`/entity/${type}/${slug}`);
  return data;
}

export async function listEntities(type, params = {}) {
  const { data } = await http.get(`/list/${type}`, { params });
  return data;
}

export async function searchEntities(q, limit = 20) {
  const { data } = await http.get(`/search`, { params: { q, limit } });
  return data;
}

// Build a router URL from an entity reference {type, slug}
export function refUrl(ref) {
  if (!ref) return "/";
  switch (ref.type) {
    case "home":
      return "/";
    case "categories":
      return "/categories";
    case "companies":
      return "/companies";
    case "services":
      return "/services";
    default:
      return `/${ref.type}/${ref.slug}`;
  }
}
